import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '../utils/text';

const DeleteButton = (props) => (
    <button type="button" className="text-btn" onClick={props.onClick}>
        <i className="icon icon--trash mr-2" />
        <span className="subtitle">{gettext('Delete')}</span>
    </button>
);

DeleteButton.propTypes = {
    onClick: PropTypes.func,
};

DeleteButton.defaultProps = {
    onClick: undefined,
};

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/components/DeleteButton.js